import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Breadcrumbs premium para el área de Consultoría.
 * Uso: <ConsultingBreadcrumbs crumbs={[{label:"Consultorías", to:"/consulting"}, {label:"TEST_Phase4"}, {label:"Herramientas"}]} />
 * El último crumb siempre se muestra como texto (no link).
 */
export default function ConsultingBreadcrumbs({ crumbs = [] }) {
  const last = crumbs.length - 1;
  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-6 md:mb-8 -mt-1"
      data-testid="consulting-breadcrumbs"
    >
      <ol className="flex items-center gap-1 flex-wrap text-xs md:text-[13px] font-medium text-slate-500">
        <li className="flex items-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-1 text-slate-400 hover:text-[#0F6E56] transition-colors"
            title="Dashboard"
            data-testid="breadcrumb-home"
          >
            <Home className="w-3.5 h-3.5" strokeWidth={2} />
          </Link>
          <ChevronRight className="w-3.5 h-3.5 text-slate-300 mx-1" />
        </li>
        {crumbs.map((c, i) => {
          const isLast = i === last;
          return (
            <li key={i} className="flex items-center min-w-0">
              {isLast || !c.to ? (
                <span
                  className={`truncate max-w-[200px] md:max-w-[320px] ${
                    isLast ? "text-slate-900 font-semibold" : ""
                  }`}
                  aria-current={isLast ? "page" : undefined}
                  data-testid={`breadcrumb-${i}`}
                >
                  {c.label}
                </span>
              ) : (
                <Link
                  to={c.to}
                  className="truncate max-w-[200px] md:max-w-[280px] hover:text-[#0F6E56] transition-colors"
                  data-testid={`breadcrumb-${i}`}
                >
                  {c.label}
                </Link>
              )}
              {!isLast && <ChevronRight className="w-3.5 h-3.5 text-slate-300 mx-1 flex-shrink-0" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
